var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"administrativeToken"},[_c('div',{staticClass:"code"},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }